import { useBaseFontSize as e, useDarkMode as n, useUsingKeyboardContext as r } from "@leafygreen-ui/leafygreen-provider";
import { BaseFontSize as a, fontFamilies as t, typeScales as o, focusRing as i } from "@leafygreen-ui/tokens";
import l, { useState as s, useEffect as d, useMemo as c } from "react";
import f from "@leafygreen-ui/box";
import { css as h, cx as u } from "@leafygreen-ui/emotion";
import { Theme as g, createUniqueClassName as m } from "@leafygreen-ui/lib";
import { palette as p } from "@leafygreen-ui/palette";
import y from "@leafygreen-ui/icon/dist/ArrowRight";
import b from "@leafygreen-ui/icon/dist/OpenNewTab";

var k,
    x,
    v,
    N,
    w,
    D,
    M,
    E,
    z,
    F,
    O,
    L,
    B,
    S = function S(n) {
  var r = e();
  return n ? 16 === n ? a.Body2 : a.Body1 : 16 === r ? a.Body2 : a.Body1;
};

function j(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function A() {
  return A = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var a in r) {
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
      }
    }

    return e;
  }, A.apply(this, arguments);
}

function H(e, n) {
  if (null == e) return {};

  var r,
      a,
      t = function (e, n) {
    if (null == e) return {};
    var r,
        a,
        t = {},
        o = Object.keys(e);

    for (a = 0; a < o.length; a++) {
      r = o[a], n.indexOf(r) >= 0 || (t[r] = e[r]);
    }

    return t;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);

    for (a = 0; a < o.length; a++) {
      r = o[a], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
    }
  }

  return t;
}

function I(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function C(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var a,
        t,
        o = [],
        i = !0,
        l = !1;

    try {
      for (r = r.call(e); !(i = (a = r.next()).done) && (o.push(a.value), !n || o.length !== n); i = !0) {
        ;
      }
    } catch (e) {
      l = !0, t = e;
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (l) throw t;
      }
    }

    return o;
  }(e, n) || function (e, n) {
    if (!e) return;
    if ("string" == typeof e) return P(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return P(e, n);
  }(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function P(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var r = 0, a = new Array(n); r < n; r++) {
    a[r] = e[r];
  }

  return a;
}

var _,
    K = h(k || (k = I(["\n  margin: unset;\n  font-family: ", ";\n  color: ", ";\n"])), t.default, p.black),
    R = (j(N = {}, a.Body1, h(x || (x = I(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), o.body1.fontSize, o.body1.lineHeight)), j(N, a.Body2, h(v || (v = I(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), o.body2.fontSize, o.body2.lineHeight)), N),
    T = (j(M = {}, a.Body1, h(w || (w = I(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), o.code1.fontSize, o.code1.lineHeight)), j(M, a.Body2, h(D || (D = I(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), o.code2.fontSize, o.code2.lineHeight)), M),
    U = (j(F = {}, g.Light, h(E || (E = I(["\n    color: ", ";\n  "])), p.black)), j(F, g.Dark, h(z || (z = I(["\n    color: ", ";\n  "])), p.gray.light2)), F),
    $ = (j(B = {}, a.Body1, h(O || (O = I(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), o.body1.fontSize, o.body1.lineHeight)), j(B, a.Body2, h(L || (L = I(["\n    font-size: ", "px;\n    line-height: 20px; // Hardcoding because it does not match body2 lineHeight\n  "])), o.body2.fontSize)), B),
    q = ["darkMode", "className", "weight", "as"],
    G = {
  default: {
    regular: 400,
    medium: 500
  },
  strong: {
    regular: 700,
    medium: 700
  }
};

function J(e) {
  var r = e.darkMode,
      a = e.className,
      t = e.weight,
      o = void 0 === t ? "regular" : t,
      i = e.as,
      s = void 0 === i ? "p" : i,
      d = H(e, q),
      c = n(r).theme,
      g = S(),
      m = h(_ || (_ = I(["\n    font-weight: ", ";\n    strong,\n    b {\n      font-weight: ", ";\n    }\n  "])), G.default[o], G.strong[o]);
  return l.createElement(f, A({
    as: s,
    className: u(K, R[g], U[c], m, a)
  }, d));
}

J.displayName = "Body";

var Q,
    V,
    W,
    X,
    Y,
    Z,
    ee,
    ne = ["darkMode", "disabled", "children", "className"],
    re = h(Q || (Q = I(["\n  font-family: ", ";\n  font-weight: normal;\n  margin-top: 0;\n  margin-bottom: 0;\n"])), t.default),
    ae = (j(X = {}, g.Light, h(V || (V = I(["\n    color: ", ";\n  "])), p.gray.dark1)), j(X, g.Dark, h(W || (W = I(["\n    color: ", ";\n  "])), p.gray.light1)), X),
    te = (j(ee = {}, g.Light, h(Y || (Y = I(["\n    color: ", ";\n  "])), p.gray.dark1)), j(ee, g.Dark, h(Z || (Z = I(["\n    color: ", ";\n  "])), p.gray.base)), ee),
    oe = function oe(e) {
  var r = e.darkMode,
      a = e.disabled,
      t = void 0 !== a && a,
      o = e.children,
      i = e.className,
      s = H(e, ne),
      d = S(),
      c = n(r).theme;
  return l.createElement("p", A({
    className: u(re, ae[c], $[d], j({}, te[c], t), i)
  }, s), o);
};

oe.displayName = "Description";
var ie,
    le,
    se,
    de,
    ce = ["darkMode", "children", "className"],
    fe = h(ie || (ie = I(["\n  display: block;\n  font-size: 11px;\n  line-height: 16px;\n  letter-spacing: 0.2px;\n"]))),
    he = (j(de = {}, g.Light, h(le || (le = I(["\n    color: ", ";\n  "])), p.gray.dark1)), j(de, g.Dark, h(se || (se = I(["\n    color: ", ";\n  "])), p.gray.light1)), de);

function ue(e) {
  var r = e.darkMode,
      a = e.children,
      t = e.className,
      o = H(e, ce),
      i = n(r).theme;
  return l.createElement("small", A({}, o, {
    className: u(K, fe, he[i], t)
  }), a);
}

ue.displayName = "Disclaimer";

var ge,
    me,
    pe,
    ye,
    be = ["darkMode", "className"],
    ke = h(ge || (ge = I(["\n  font-weight: 400;\n  font-size: 48px;\n  line-height: 62px;\n  font-family: ", ";\n"])), t.serif),
    xe = (j(ye = {}, g.Light, h(me || (me = I(["\n    color: ", ";\n  "])), p.green.dark2)), j(ye, g.Dark, h(pe || (pe = I(["\n    color: ", ";\n  "])), p.green.light1)), ye),
    ve = function ve(e) {
  var r = e.darkMode,
      a = e.className,
      t = H(e, be),
      o = n(r).theme;
  return l.createElement(f, A({
    as: "h1",
    className: u(K, ke, xe[o], a)
  }, t));
};

ve.displayName = "H1";

var Ne,
    we,
    De,
    Me,
    Ee = ["darkMode", "className"],
    ze = h(Ne || (Ne = I(["\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 400;\n  font-family: ", ";\n"])), t.serif),
    Fe = (j(Me = {}, g.Light, h(we || (we = I(["\n    color: ", ";\n  "])), p.green.dark2)), j(Me, g.Dark, h(De || (De = I(["\n    color: ", ";\n  "])), p.green.light1)), Me),
    Oe = function Oe(e) {
  var r = e.darkMode,
      a = e.className,
      t = H(e, Ee),
      o = n(r).theme;
  return l.createElement(f, A({
    as: "h2",
    className: u(K, ze, Fe[o], a)
  }, t));
};

Oe.displayName = "H2";

var Le,
    Be = ["darkMode", "className"],
    Se = h(Le || (Le = I(["\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 500;\n"]))),
    je = function je(e) {
  var r = e.darkMode,
      a = e.className,
      t = H(e, Be),
      o = n(r).theme;
  return l.createElement(f, A({
    as: "h3",
    className: u(K, Se, U[o], a)
  }, t));
};

je.displayName = "H3";

var Ae,
    He,
    Ie,
    Ce,
    Pe,
    _e,
    Ke,
    Re,
    Te,
    Ue,
    $e,
    qe,
    Ge,
    Je = ["children", "className", "darkMode"],
    Qe = m(),
    Ve = h(Ae || (Ae = I(["\n  transition: all 0.15s ease-in-out;\n  border-radius: 3px;\n  font-family: ", ";\n  line-height: 20px;\n  display: inherit;\n\n  .", ":hover > & {\n    text-decoration: none;\n  }\n"])), t.code, Qe),
    We = (j(Ce = {}, g.Light, h(He || (He = I(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n\n    .", ":hover > & {\n      box-shadow: 0 0 0 3px ", ";\n      border: 1px solid ", ";\n    }\n  "])), p.gray.light3, p.gray.light2, p.gray.dark3, Qe, p.gray.light2, p.gray.light1)), j(Ce, g.Dark, h(Ie || (Ie = I(["\n    background-color: transparent;\n    border: 1px solid ", ";\n    color: ", ";\n\n    .", ":hover > & {\n      box-shadow: 0 0 0 3px ", ";\n      border: 1px solid ", ";\n    }\n  "])), p.gray.dark2, p.gray.light1, Qe, p.gray.dark2, p.gray.dark1)), Ce),
    Xe = (j(Ke = {}, g.Light, h(Pe || (Pe = I(["\n    .", ":focus > & {\n      box-shadow: ", ";\n      border: 1px solid ", ";\n    }\n  "])), Qe, i[g.Light].default, p.blue.base)), j(Ke, g.Dark, h(_e || (_e = I(["\n    .", ":focus > & {\n      box-shadow: ", ";\n      border: 1px solid ", ";\n    }\n  "])), Qe, i[g.Dark].default, p.blue.base)), Ke),
    Ye = (j(Ue = {}, g.Light, h(Re || (Re = I(["\n    color: ", ";\n  "])), p.blue.base)), j(Ue, g.Dark, h(Te || (Te = I(["\n    color: ", ";\n  "])), p.blue.light1)), Ue),
    Ze = h($e || ($e = I(["\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n  line-height: 20px;\n\n  &:focus {\n    outline: none;\n  }\n"]))),
    en = h(qe || (qe = I(["\n  white-space: nowrap;\n"]))),
    nn = h(Ge || (Ge = I(["\n  white-space: normal;\n"])));

function rn(e) {
  var a,
      t,
      o,
      i = e.children,
      s = e.className,
      d = e.darkMode,
      c = H(e, Je),
      f = r().usingKeyboard,
      h = S(),
      g = n(d).theme,
      m = (null !== (a = "string" == typeof i && (null === (t = i.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) || void 0 === t ? void 0 : t.length)) && void 0 !== a ? a : 0) <= 30 ? en : nn,
      p = void 0 !== (null == c ? void 0 : c.href) || void 0 !== c.onClick,
      y = l.createElement("code", {
    className: u(T[h], Ve, We[g], m, (o = {}, j(o, Ye[g], p), j(o, Xe[g], f), o), s)
  }, i);
  return p ? l.createElement("a", A({
    className: u(Qe, Ze, s)
  }, c), y) : l.cloneElement(y, c);
}

rn.displayName = "InlineCode";
var an,
    tn,
    on,
    ln,
    sn = ["darkMode", "children", "className"],
    dn = h(an || (an = I(["\n  font-family: ", ";\n  border: 1px solid;\n  border-radius: 3px;\n  padding-left: 5px;\n  padding-right: 5px;\n"])), t.code),
    cn = (j(ln = {}, g.Light, h(tn || (tn = I(["\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n  "])), p.black, p.gray.dark3, p.white)), j(ln, g.Dark, h(on || (on = I(["\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n  "])), p.gray.light2, p.gray.base, p.gray.dark3)), ln);

function fn(e) {
  var r = e.darkMode,
      a = e.children,
      t = e.className,
      o = H(e, sn),
      i = S(),
      s = n(r).theme;
  return l.createElement("code", A({
    className: u(dn, cn[s], T[i], t)
  }, o), a);
}

fn.displayName = "InlineKeyCode";

var hn,
    un,
    gn,
    mn,
    pn,
    yn,
    bn,
    kn = ["darkMode", "className", "children", "disabled"],
    xn = h(hn || (hn = I(["\n  font-family: ", ";\n  font-weight: bold;\n"])), t.default),
    vn = (j(mn = {}, g.Light, h(un || (un = I(["\n    color: ", ";\n  "])), p.black)), j(mn, g.Dark, h(gn || (gn = I(["\n    color: ", ";\n  "])), p.gray.light2)), mn),
    Nn = (j(bn = {}, g.Light, h(pn || (pn = I(["\n    color: ", ";\n  "])), p.gray.dark1)), j(bn, g.Dark, h(yn || (yn = I(["\n    color: ", ";\n  "])), p.gray.base)), bn),
    wn = function wn(e) {
  var r = e.darkMode,
      a = e.className,
      t = e.children,
      o = e.disabled,
      i = void 0 !== o && o,
      s = H(e, kn),
      d = S(),
      c = n(r).theme;
  return l.createElement("label", A({
    className: u(xn, vn[c], $[d], j({}, Nn[c], i), a)
  }, s), t);
};

wn.displayName = "Label";

var Dn,
    Mn,
    En,
    zn,
    Fn,
    On,
    Ln,
    Bn,
    Sn,
    jn,
    An,
    Hn,
    In = ["href", "children", "className", "target", "arrowAppearance", "hideExternalIcon", "darkMode"],
    Cn = m(),
    Pn = h(Dn || (Dn = I(["\n  font-family: ", ";\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n  cursor: pointer;\n  line-height: 13px;\n\n  &:focus {\n    outline: none;\n  }\n"])), t.default),
    _n = (j(zn = {}, g.Light, h(Mn || (Mn = I(["\n    color: ", ";\n    font-weight: 400;\n  "])), p.blue.base)), j(zn, g.Dark, h(En || (En = I(["\n    color: ", ";\n    font-weight: 700;\n  "])), p.blue.light1)), zn),
    Kn = h(Fn || (Fn = I(["\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    bottom: -4px;\n    left: 0;\n    border-radius: 2px;\n  }\n\n  .", ":focus & {\n    &::after {\n      background-color: ", ";\n    }\n  }\n"])), Cn, p.blue.light1),
    Rn = (j(Bn = {}, g.Light, h(On || (On = I(["\n    .", ":hover & {\n      &::after {\n        background-color: ", ";\n      }\n    }\n  "])), Cn, p.gray.light2)), j(Bn, g.Dark, h(Ln || (Ln = I(["\n    .", ":hover & {\n      &::after {\n        background-color: ", ";\n      }\n    }\n  "])), Cn, p.gray.dark2)), Bn),
    Tn = h(Sn || (Sn = I(["\n  transform: translate3d(3px, 0, 0);\n"]))),
    Un = h(jn || (jn = I(["\n  opacity: 0;\n  transform: translate3d(-3px, 0, 0);\n  transition: all 100ms ease-in;\n\n  .", ":hover & {\n    opacity: 1;\n    transform: translate3d(3px, 0, 0);\n  }\n"])), Cn),
    $n = h(An || (An = I(["\n  position: relative;\n  bottom: 4px;\n  left: -1px;\n  height: 12px;\n"]))),
    qn = "hover",
    Gn = "persist",
    Jn = "none",
    Qn = function Qn(e) {
  var r = e.href,
      a = e.children,
      t = e.className,
      o = e.target,
      i = e.arrowAppearance,
      h = void 0 === i ? Jn : i,
      g = e.hideExternalIcon,
      m = void 0 !== g && g,
      p = e.darkMode,
      k = H(e, In),
      x = C(s(""), 2),
      v = x[0],
      N = x[1];
  d(function () {
    N(window.location.hostname);
  }, []);
  var w,
      D,
      M,
      E = n(p).theme,
      z = c(function () {
    if (r) {
      return /^http(s)?:\/\//.test(r) ? new URL(r).hostname : v;
    }
  }, [r, v]),
      F = S();

  if (o ? w = o : z === v ? w = "_self" : (w = "_blank", M = "noopener noreferrer"), "_blank" !== w || m) {
    if (h !== Jn) {
      var O;
      D = l.createElement(y, {
        role: "presentation",
        size: 12,
        className: u((O = {}, j(O, Un, h === qn), j(O, Tn, h === Gn), O))
      });
    }
  } else D = l.createElement(b, {
    role: "presentation",
    className: $n
  });

  var L = r ? {
    as: "a",
    href: r,
    target: w,
    rel: M
  } : {
    as: "span"
  };
  return l.createElement(f, A({
    className: u(Cn, R[F], Pn, _n[E], t)
  }, L, k), l.createElement("span", {
    className: u(Kn, Rn[E])
  }, a), D);
},
    Vn = ["darkMode", "className"],
    Wn = h(Hn || (Hn = I(["\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  line-height: 20px;\n  letter-spacing: 0.4px;\n"]))),
    Xn = function Xn(e) {
  var r = e.darkMode,
      a = e.className,
      t = H(e, Vn),
      o = n(r).theme;
  return l.createElement(f, A({
    className: u(K, Wn, U[o], a)
  }, t));
};

Xn.displayName = "Overline";

var Yn,
    Zn = ["darkMode", "className"],
    er = h(Yn || (Yn = I(["\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 700;\n"]))),
    nr = function nr(e) {
  var r = e.darkMode,
      a = e.className,
      t = H(e, Zn),
      o = n(r).theme;
  return l.createElement(f, A({
    as: "h6",
    className: u(K, er, U[o], a)
  }, t));
};

nr.displayName = "Subtitle";
export { J as Body, oe as Description, ue as Disclaimer, ve as H1, Oe as H2, je as H3, rn as InlineCode, fn as InlineKeyCode, wn as Label, Qn as Link, Xn as Overline, nr as Subtitle, Cn as anchorClassName, R as bodyTypeScaleStyles, $ as labelTypeScaleStyles, S as useUpdatedBaseFontSize };